module.exports = __webpack_public_path__ + "media/images/demo-poster-2e8eb83e0881f71d8c27941eb8560de2.png";